import {ResolutionsInterface} from '../../services/media-query/resolutions.interface';

export const gutterSizer = (currentSize: ResolutionsInterface) => {
  const mapping: Record<keyof ResolutionsInterface, string> = {
    isMobile: '10px',
    isTablet: '7px',
    isFullHD: '10px',
    isQHD: '15px',
    isUHD: '20px'
  };

  return sizeFinder(currentSize, mapping);
}

export const rowSizer = (currentSize: ResolutionsInterface) => {
  const mapping: Record<keyof ResolutionsInterface, string> = {
    isMobile: '75px',
    isTablet: '70px',
    isFullHD: '85px',
    isQHD: '100px',
    isUHD: '150px'
  };

  return sizeFinder(currentSize, mapping);
}

export const rankingsTitleRowSizer = (currentSize: ResolutionsInterface) => {
  const mapping: Record<keyof ResolutionsInterface, string> = {
    isMobile: '25px',
    isTablet: '20px',
    isFullHD: '25px',
    isQHD: '30px',
    isUHD: '50px'
  };

  return sizeFinder(currentSize, mapping);
}

export const rankingsTableRowSizer = (currentSize: ResolutionsInterface) => {
  const mapping: Record<keyof ResolutionsInterface, string> = {
    isMobile: '50px',
    isTablet: '30px',
    isFullHD: '30px',
    isQHD: '40px',
    isUHD: '50px'
  };

  return sizeFinder(currentSize, mapping);
}


const sizeFinder = (currentSize: ResolutionsInterface, mapping: Record<keyof ResolutionsInterface, string>): string => {
  const currActiveKey: keyof ResolutionsInterface = (Object.keys(currentSize) as Array<keyof ResolutionsInterface>).filter(
    (key) => currentSize[key]
  ).pop() as keyof ResolutionsInterface;

  return mapping[currActiveKey]
}
